import { render, staticRenderFns } from "./viewReport.vue?vue&type=template&id=20d2b12f&scoped=true&"
import script from "./viewReport.vue?vue&type=script&lang=ts&"
export * from "./viewReport.vue?vue&type=script&lang=ts&"
import style0 from "./viewReport.vue?vue&type=style&index=0&id=20d2b12f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2b12f",
  null
  
)

export default component.exports